// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"99":"e021d584","117":"2dcc7d32","326":"e448f917","390":"36467fae","758":"a932b626","927":"d069ab62","970":"12e6df47"}[chunkId] + ".js";
};